module.exports = __webpack_public_path__ + "static/bill-gates-196761796be44b579e1f9cb4711550aa.jpg";